/**
 * Spec №11 Stage 3 — resolve an entity type's default declared list + record
 * views (ViewNodeConfig). Views are library nodes carrying `view_config`; the
 * default per (entity_type, view_type) is preferred, else the first of that kind.
 * These drive the App Shell declared-view renderers; when absent the renderers
 * fall back to sensible defaults from the entity type.
 */
import { useViews } from "../../lib/hooks/use-kuvio";
import type { LibraryNode, ViewNodeConfig } from "../../lib/types";

function pickDefault(nodes: LibraryNode[] | undefined, viewType: string): ViewNodeConfig | undefined {
  const ofType = (nodes ?? []).filter((n) => n.view_config?.view_type === viewType);
  const chosen = ofType.find((n) => n.view_config?.is_default) ?? ofType[0];
  return chosen?.view_config ?? undefined;
}

export function usePlaceViews(slug?: string) {
  const q = useViews(slug);
  return {
    ...q,
    listView: pickDefault(q.data, "list"),
    recordView: pickDefault(q.data, "record"),
  };
}
